export default "__VITE_ASSET__CrLAzNrx__"